var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcademicsOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2501 17.5515V5.93415C22.2542 5.66648 22.2016 5.40096 22.0958 5.15509C21.9899 4.90922 21.8331 4.68856 21.6358 4.50762C21.4385 4.32669 21.2051 4.18958 20.951 4.10533C20.6969 4.02107 20.4279 3.99157 20.1615 4.01878H20.1038C17.7063 4.31847 15.3927 5.09402 13.299 6.2999L13.1353 6.40578C12.9788 6.49103 12.8034 6.53569 12.6252 6.53569C12.447 6.53569 12.2716 6.49103 12.115 6.40578L11.8744 6.26139C9.78241 5.06457 7.47193 4.29877 5.07922 4.00916C4.81357 3.98293 4.5454 4.01317 4.29226 4.09791C4.03912 4.18265 3.80678 4.31998 3.61045 4.50085C3.41413 4.68173 3.25822 4.90206 3.15306 5.14742C3.0479 5.39278 2.99585 5.65762 3.00026 5.92453V17.5515C3.01173 18.015 3.18573 18.4599 3.49185 18.8082C3.79796 19.1566 4.21672 19.3863 4.67499 19.4572L4.95415 19.4957C7.4471 19.9081 9.86207 20.7001 12.115 21.8442L12.1536 21.8634C12.2972 21.9347 12.4553 21.9717 12.6156 21.9717C12.7759 21.9717 12.934 21.9347 13.0775 21.8634C15.3341 20.7075 17.7563 19.9088 20.2578 19.4957L20.5754 19.4572C21.0337 19.3863 21.4524 19.1566 21.7586 18.8082C22.0647 18.4599 22.2387 18.015 22.2501 17.5515Z",
    stroke: "#6A6A6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.625 6.72339V21.1608",
    stroke: "#6A6A6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53426 9.61096H6.36865",
    stroke: "#6A6A6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25613 12.4984H6.36865",
    stroke: "#6A6A6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademicsOutline);
export default __webpack_public_path__ + "static/media/academics_outline.8e090f38f1fe858f072f7ea14cc0bcb8.svg";
export { ForwardRef as ReactComponent };